module.exports = __webpack_public_path__ + "media/images/emblems/Saint-Sulpice-coat_of_arms-d53040d66e13df64031f5ddacd0d68af.svg";